import { lazy, Suspense, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import { useAuth } from '../auth/AuthProvider';
import { RemoteErrorBoundary } from '../components/RemoteErrorBoundary';
import { useT } from '../i18n';

/** The federated tenant-admin remote, loaded on demand at /tenants. */
const RemoteTenantAdminApp = lazy(() => import('tenantAdmin/App'));

export function TenantAdminRoute() {
  const { user, loading, login, roles } = useAuth();
  const t = useT();

  useEffect(() => {
    if (!loading && !user) {
      login();
    }
  }, [loading, user, login]);

  if (loading) {
    return (
      <Box className="flex justify-center py-12">
        <CircularProgress />
      </Box>
    );
  }

  if (!user) {
    return (
      <Box className="flex justify-center py-12">
        <CircularProgress />
      </Box>
    );
  }

  // Platform admins onboard and manage clients inside the console.
  if (roles.includes('ADMIN')) {
    return <Navigate to="/admin" replace />;
  }

  return (
    <RemoteErrorBoundary fallbackMessage={t('Feature unavailable — is tenant-admin running?')}>
      <Suspense
        fallback={
          <Box className="flex justify-center py-12">
            <CircularProgress />
          </Box>
        }
      >
        <RemoteTenantAdminApp />
      </Suspense>
    </RemoteErrorBoundary>
  );
}
